/* __next_internal_client_entry_do_not_use__ Chevron,ChevronDown,ChevronLeft,ChevronRight,ChevronUp auto */ import { Chevron as ReactChevron, ChevronDown as ReactChevronDown, ChevronLeft as ReactChevronLeft, ChevronRight as ReactChevronRight, ChevronUp as ReactChevronUp } from "./deprecated/Chevron";
export var Chevron = ReactChevron;
export var ChevronDown = ReactChevronDown;
export var ChevronLeft = ReactChevronLeft;
export var ChevronRight = ReactChevronRight;
export var ChevronUp = ReactChevronUp;
